import { render } from "./StopsIcon.vue?vue&type=template&id=01db4216"
const script = {}
script.render = render

export default script